import React, { useEffect, useState } from 'react';
import { StepContainer, NavigationButtons, FormField, InfoBox } from '../index';
import { useWizard } from '../../wizard';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const CancelSmsStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [error, setError] = useState<string>('');
  const [body, setBody] = useState<string[] | null>(null);
  useEffect(() => {
    contentApi.getByKey(contentKeys.afbestil.bk_sms).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const onNext = () => {
    if (!selfServiceData.cancelSmsCode?.trim()) {
      setError('Indtast SMS‑kode.');
      return;
    }
    // Simuler godkendt kode (1234)
    if (selfServiceData.cancelSmsCode !== '1234') {
      setError('Ugyldig kode. Prøv igen (hint: 1234).');
      return;
    }
    setError('');
    goNext();
  };

  return (
    <StepContainer title="Bekræft med SMS‑kode">
      {body ? (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      ) : (
        <InfoBox type="info">
          <p>Vi har sendt en SMS‑kode til {selfServiceData.cancelPhone}. Indtast koden for at bekræfte afbestillingen.</p>
        </InfoBox>
      )}
      <div style={{ maxWidth: 320 }}>
        <FormField
          name="cancelSmsCode"
          value={selfServiceData.cancelSmsCode || ''}
          placeholder="SMS‑kode"
          error={error}
          onChange={(e) => updateSelfServiceData('cancelSmsCode', e.target.value)}
          autoComplete="one-time-code"
        />
      </div>
      <NavigationButtons onBack={goBack} onNext={onNext} />
    </StepContainer>
  );
};

export default CancelSmsStep;
